module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical masthead center aligned segment",
    attrs: {
      "id": "home-section"
    }
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Pricing'
      }
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login In")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui text container"
  }, [_c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        VX Data\n      ")]), _vm._v(" "), _c('h2', [_vm._v("Latest real estate market data")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui huge primary button",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "right arrow icon"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical stripe segment",
    attrs: {
      "id": "data-section"
    }
  }, [_c('div', {
    staticClass: "ui middle aligned stackable grid container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "center aligned column"
  }, [_c('router-link', {
    staticClass: "ui huge primary butto",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Sign Up")])], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "eight wide column"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Latest market data available each week")]), _vm._v(" "), _c('p', [_vm._v("Every week we take a snapshot of the housing market across the entire US.")]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Simple data format")]), _vm._v(" "), _c('p', [_vm._v("Plain old CSV, already clean, easy to load into your pipeline. (See example CSV.)")]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Historical data, going back ten years*")]), _vm._v(" "), _c('p', [_vm._v("We've been doing this a while. With all plans, you'll get the last 12 months of market data.")]), _vm._v(" "), _c('small', [_vm._v("*historical data is available at additional cost.")])]), _vm._v(" "), _c('div', {
    staticClass: "six wide right floated column"
  }, [_c('img', {
    staticClass: "ui large bordered rounded image",
    attrs: {
      "src": "static/anna-goncharova-73258.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui vertical stripe quote segment"
  }, [_c('div', {
    staticClass: "ui equal width stackable internally celled grid"
  }, [_c('div', {
    staticClass: "center aligned row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("\"Up and running in minutes\"")]), _vm._v(" "), _c('p', [_vm._v("That is what they all say about us")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("\"No munging required.\"")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "ui avatar image",
    attrs: {
      "src": "assets/images/avatar/nan.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Sheila")]), _vm._v(" Chief Data Scientist Acme Toys\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui vertical stripe segment"
  }, [_c('div', {
    staticClass: "ui text container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Breaking The Grid, Grabs Your Attention")]), _vm._v(" "), _c('p', [_vm._v("Instead of focusing on content creation and hard work, we have learned how to master the art of doing nothing by providing massive amounts of whitespace and generic content that can seem massive, monolithic and worth your attention.")]), _vm._v(" "), _c('a', {
    staticClass: "ui large button"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('h4', {
    staticClass: "ui horizontal header divider"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Case Studies")])]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Did We Tell You About Our Bananas?")]), _vm._v(" "), _c('p', [_vm._v("Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but its really true. It took years of gene splicing and combinatory DNA research, but our bananas can really dance.")]), _vm._v(" "), _c('a', {
    staticClass: "ui large button"
  }, [_vm._v("I'm Still Quite Interested")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted vertical footer segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui stackable inverted divided equal height stackable grid"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sitemap")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Religious Ceremonies")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Gazebo Plans")])])]), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Services")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Banana Pre-Order")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("DNA FAQ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("How To Access")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Favorite X-Men")])])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Footer Header")]), _vm._v(" "), _c('p', [_vm._v("Extra space for a call to action inside the footer that could help re-engage users.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162a1eba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 99
// module chunks = 1